module.exports = __webpack_public_path__ + "static/media/Menu-4.7f617a10.jpg";